import { useTranslation } from 'react-i18next';
import name_logo from '../images/WillowTec_logo.png';
import logo from '../images/logo.png'

function Footer() {
  const { t } = useTranslation();
  const services = t('footer.services', { returnObjects: true });

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <a href="#top" className="brand">
            <img src={ logo } alt="WillowTec logo" className="brand-logo" />
            <span>{t('company.name')}</span>
          </a>

          <p>{t('footer.description')}</p>
        </div>

        <div className="footer-column">
          <h3>{t('footer.companyTitle')}</h3>
          <a href="#services">{t('nav.services')}</a>
          <a href="#technology">{t('nav.technology')}</a>
          <a href="#rails">{t('nav.rails')}</a>
          <a href="#solutions">{t('nav.solutions')}</a>
          <a href="#flexibility">{t('nav.flexibility')}</a>
          <a href="#process">{t('nav.process')}</a>
        </div>

        <div className="footer-column">
          <h3>{t('footer.servicesTitle')}</h3>
          {services.map((service) => (
            <span key={service}>{service}</span>
          ))}
        </div>

        <div className="footer-column">
          <h3>{t('footer.infoTitle')}</h3>
          <img src={ name_logo } alt="WillowTec logo" className="brand-logo" />
          <span>{t('footer.info.address')}</span>
          <span>{t('footer.info.email')}</span>
          <span>{t('footer.info.phone')}</span>
          <span>{t('footer.info.businessId')}</span>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.bottom.copy')}</p>

        <div className="footer-links">
          <a href="#top">{t('footer.bottom.backToTop')}</a>
          <a href="#contact">{t('footer.bottom.contact')}</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;